module.exports = __webpack_public_path__ + "static/media/logo-icon.9e547022.png";